import * as React from "react";
import { FormTextArea } from "semantic-ui-react";
import * as _ from "lodash";

export type InputTextProps = {
  id: string;
  name: string;
  value: string;
  isError: boolean;
  handleInputChanged: (value: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
};

type InputTextState = {
  value: string;
};

// The wrapper component for displaying the text input field.
// The component has user's input in own state and waits a delay
// before passes the input value outside.
class InputText extends React.Component<InputTextProps, InputTextState> {
  // Delay after user's input is passed outside
  static searchInputDelay = 500;

  static defaultProps = {
    disabled: false,
    readonly: false
  };

  state = { value: "" };

  componentDidUpdate(prevProps: InputTextProps): void {
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value
      });
    }
  }

  componentDidMount(): void {
    this.setState({
      value: this.props.value
    });
    // make throttle function
    this.handleOnChangeDebounced = _.debounce(
      this.handleOnChangeDebounced,
      InputText.searchInputDelay
    );
  }

  render(): JSX.Element {
    const { isError, name, disabled, id,readOnly } = this.props;
    return (
      <FormTextArea
        id={id}
        label={name}
        rows={1}
        value={this.state.value}
        error={isError}
        // eslint-disable-next-line
        onChange={({ }, { value }: any) => this.handleOnChange(value)}
        readOnly={readOnly}
        disabled={disabled}
      />
    );
  }

  // Handler of input changed
  private handleOnChange = (value: string): void => {
    this.setState({
      value
    });
    this.handleOnChangeDebounced(value);
  };

  // Debounced handler
  private handleOnChangeDebounced = (value: string): void => {
    this.props.handleInputChanged(value);
  };
}

export default InputText;
